import React from 'react';
import EventsList from '../components/Events/EventsList';

const CalendrierPage: React.FC = () => {
  return (
    <>
    <div className="product-grid" style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', justifyContent: 'center' }}>

          <p>Balade possible tout les jours, pensez a appeler pour ouvrir un créneau</p>

      </div>
      <EventsList />
    </>
  );
};

export default CalendrierPage;